import addToCart from '../lib/addToCart';
import getCart from '../lib/getCart';
import renderMinicart from '../lib/renderMinicart';
import initRecipeTabs from '../components/recipesTabs';
import { SELECTORS } from '../utils/constants';
import { lockBodyScroll, unlockBodyScroll } from '../utils/bodyScrollLock';
import trapFocus from '../utils/trapFocus';

const initArticleRecipe = () => {
  const addProductsToCart = (section) => {
    const atcBtn = section.querySelector('[data-recipe-products-atc]');
    const atcBtnSpinner = atcBtn?.querySelector(SELECTORS.LOADING_SPINNER);
    if (!atcBtn) return;

    const forms = section.querySelectorAll('[data-product-form-recipe]');
    if (!forms.length) return;

    const setBtnLoadingState = (button, spinner, loading) => {
      button.classList.toggle('pointer-events-none', loading);
      button.classList.toggle('opacity-50', loading);
      if (spinner) spinner.classList.toggle('hidden', !loading);
    };

    atcBtn.addEventListener('click', async () => {
      atcBtn.disabled = true;
      setBtnLoadingState(atcBtn, atcBtnSpinner, atcBtn.disabled);
      try {
        const productIds = [...forms]
          .map(form => form.querySelector('input[name="id"]')?.value)
          .filter(Boolean);
        if (!productIds.length) return;

        await Promise.all(productIds.map(id => addToCart(id, 1)));
        const cart = await getCart();
        await renderMinicart();
        window.theme.cartToast?.show({ cartTotal: cart.total_price });
      } catch (error) {
        console.error('ATC error:', error);
      } finally {
        atcBtn.disabled = false;
        setBtnLoadingState(atcBtn, atcBtnSpinner, atcBtn.disabled);
      }
    });
  };

  const initCommentsDrawer = (section) => {
    const openBtn = section.querySelector('[data-recipe-comments-open]');
    const drawer = section.querySelector('[data-recipe-comments-drawer]');
    const panel = drawer?.querySelector('[data-recipe-comments-panel]');
    const closeBtn = drawer?.querySelector('[data-recipe-comments-close]');
    const overlay = drawer?.querySelector('[data-recipe-comments-overlay]');
    const status = drawer?.querySelector('[data-recipe-comments-status]');
    if (!openBtn || !drawer || !panel || !closeBtn || !overlay) return;

    const scrollLockToken = `recipe-comments-${panel.id}`;
    let previouslyFocusedElement = null;

    const setDrawerState = (isOpen) => {
      drawer.classList.toggle('pointer-events-none', !isOpen);
      drawer.classList.toggle('opacity-0', !isOpen);
      drawer.classList.toggle('opacity-100', isOpen);
      drawer.setAttribute('aria-hidden', String(!isOpen));
      drawer.inert = !isOpen;
      openBtn.setAttribute('aria-expanded', String(isOpen));
      panel.classList.toggle('translate-y-full', !isOpen);
      panel.classList.toggle('translate-y-0!', isOpen);
      panel.classList.toggle('lg:translate-x-full', !isOpen);
      panel.classList.toggle('lg:translate-x-0!', isOpen);

      if (isOpen) {
        previouslyFocusedElement = document.activeElement;
        lockBodyScroll(scrollLockToken);
        closeBtn.focus();
      }
      else {
        unlockBodyScroll(scrollLockToken);
        if (previouslyFocusedElement instanceof HTMLElement) {
          previouslyFocusedElement.focus();
        }
      }
    };

    openBtn.addEventListener('click', () => setDrawerState(true));
    closeBtn.addEventListener('click', () => setDrawerState(false));
    overlay.addEventListener('click', () => setDrawerState(false));
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setDrawerState(false);
    });
    trapFocus(panel);

    if (drawer.hasAttribute('data-recipe-comments-auto-open')) {
      setDrawerState(true);
      status?.focus();
    }
  };

  document.querySelectorAll('[data-article-recipe]').forEach(section => {
    if (section.dataset.articleRecipeInitialized === 'true') return;
    section.dataset.articleRecipeInitialized = 'true';

    initRecipeTabs(section);
    addProductsToCart(section);
    initCommentsDrawer(section);
  });
};

export default initArticleRecipe;
